export function pwScore(pw: string): number {
  let n = 0;
  if (pw.length >= 8) n++;
  if (/[A-Z]/.test(pw)) n++;
  if (/[0-9]/.test(pw)) n++;
  if (/[^A-Za-z0-9]/.test(pw)) n++;
  return n;
}

const BAR_EMPTY = "#E5E7EB";
const SCORE_COLORS: Record<number, string> = {
  1: "#E02424",
  2: "#F59E0B",
  3: "#10B981",
  4: "#059669",
};
const SCORE_LABELS: Record<number, string> = {
  1: "Weak",
  2: "Fair",
  3: "Good",
  4: "Strong",
};

export function PasswordStrengthBar({ pw }: { pw: string }) {
  const score = pwScore(pw);
  const color = SCORE_COLORS[score] ?? BAR_EMPTY;
  const label = SCORE_LABELS[score] ?? "";

  return (
    <div>
      <div style={{ display: "flex", gap: 4, marginBottom: 4 }}>
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            style={{
              flex: 1,
              height: 3,
              borderRadius: 9999,
              background: score > 0 && i <= score ? color : BAR_EMPTY,
            }}
          />
        ))}
      </div>
      {pw && score > 0 && (
        <span style={{ fontSize: 12, color, fontWeight: 500 }}>{label}</span>
      )}
    </div>
  );
}
